/* eslint-disable camelcase */
import React from 'react';
import { Icon, Message, MessageProps } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import NoPACSCommunicationError from 'app/errors/NoPACSCommunicationError';
import InvalidImageError from 'app/errors/InvalidImageError';
import { PACSStoreError } from 'app/dicom/syncImageWithPACS';
import NotFoundError from 'app/errors/NotFoundError';
import { ERROR_STATUS } from 'app/native/node-addons/picoxia-dicom';

type PACSErrorMessageProps = Omit<MessageProps, 'error'> & {
  error: PACSStoreError;
  titleID: string;
  title?: React.ReactNode;
};

function PACSErrorMessage({
  error,
  titleID,
  title = undefined,
  size = undefined,
}: PACSErrorMessageProps) {
  if (error === undefined) return null;

  let message: string;
  let errorIntlKey: string;
  let errorComment: string;
  if (error instanceof NoPACSCommunicationError) {
    errorIntlKey = 'error.pacs_store.NoPACSCommunicationError';
  } else if (error instanceof InvalidImageError) {
    errorIntlKey = 'error.pacs_store.InvalidImageError';
  } else if (error instanceof NotFoundError) {
    errorIntlKey = 'error.pacs_store.NotFoundError';
  } else if (error instanceof Error) {
    message = error.message;
  } else {
    const { status = ERROR_STATUS.UNKNOWN, error_comment } = error ?? {};
    errorComment = error_comment;
    message = status;
    errorIntlKey = `pacs.association_error.${status}`;
  }

  return (
    <Message error icon size={size}>
      <Icon name="warning sign" />
      <Message.Content>
        <Message.Header>{title ?? <FormattedMessage id={titleID} />}</Message.Header>
        <p>
          {errorIntlKey ? <FormattedMessage id={errorIntlKey} defaultMessage={message} /> : message}
        </p>
        {errorComment && <p>{errorComment}</p>}
      </Message.Content>
    </Message>
  );
}

export default PACSErrorMessage;
